import { CircleCheckIcon } from '@components/icons/CircleCheckIcon'
import { PlusCircleIcon } from '@components/icons/PlusCircleIcon'
import { WriterStatusEnum } from '@interfaces/WriterStatusEnum'
import { WriterStatusProps } from './interface'

export function WriterStatus({
  status,
  rejectedReason,
  firstUpgradeToWriter,
}: WriterStatusProps) {
  if (
    status === WriterStatusEnum.CREATED_REJECTED ||
    status === WriterStatusEnum.EDITED_REJECTED
  ) {
    return (
      <div className='flex border border-red rounded-[8px] overflow-hidden mb-[20px] text-red text-[14px] font-light mobile:mb-[10px] mobile:flex-col'>
        <div className='flex space-x-[10px] items-center p-[12px] bg-red-5 font-mitr desktop-tablet:border-r border-red mobile:border-b'>
          <PlusCircleIcon className='rotate-45' />
          <span className='whitespace-nowrap'>
            {firstUpgradeToWriter ? 'ไม่อนุมัติ' : 'ไม่อนุมัติการแก้ไข'}
          </span>
        </div>
        <div className='p-[16px_12px] text-[12px] whitespace-pre-line mobile:p-[10px_12px]'>
          {rejectedReason}
        </div>
      </div>
    )
  }

  if (status === WriterStatusEnum.APPROVED) {
    return (
      <div className='border border-green p-[12px] rounded-[8px] flex items-center space-x-[10px] text-[14px] text-green font-light font-mitr bg-green-1 dark:bg-dark-8 mb-[20px] mobile:mb-[10px]'>
        <CircleCheckIcon />
        <span>ได้รับการอนุมัติ</span>
      </div>
    )
  }

  return null
}
